import {forwardRef} from 'react'
import type {IconProps} from '../types'

export const StarIcon = forwardRef<SVGSVGElement, IconProps>(
  ({size = 20, color = 'currentColor', className, ...props}, ref) => (
    <svg
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 22 22"
      fill="none"
      className={className}
      aria-hidden="true"
      {...props}
    >
      <path
        d="M19.6514 10.5093C20.1135 10.0412 20.2832 9.34389 20.0852 8.70639C19.8871 8.05893 19.3685 7.59077 18.7179 7.50112L14.6067 6.88354C14.4936 6.86362 14.3993 6.79389 14.3427 6.68432L12.504 2.80951C12.2211 2.20189 11.6365 1.83333 10.9953 1.83333C10.3541 1.83333 9.76947 2.21185 9.48659 2.80951L7.64787 6.68432C7.60073 6.79389 7.497 6.86362 7.38385 6.88354L3.28209 7.50112C2.6409 7.60073 2.11285 8.05893 1.91484 8.70639C1.71682 9.35385 1.88655 10.0412 2.34859 10.5093L5.31883 13.5275C5.39426 13.6072 5.43198 13.7267 5.41312 13.8363L4.71535 18.0996C4.6022 18.757 4.85679 19.4244 5.3754 19.8228C5.89402 20.2213 6.58236 20.281 7.15755 19.9623L10.8256 17.9502C10.9293 17.8904 11.0519 17.8904 11.1556 17.9502L14.833 19.9623C15.0782 20.1017 15.3516 20.1615 15.6157 20.1615C15.9645 20.1615 16.3134 20.042 16.6152 19.8129C17.1338 19.4144 17.3789 18.757 17.2752 18.0896L16.5775 13.8263C16.5586 13.7168 16.5963 13.5972 16.6717 13.5175L19.642 10.4994L19.6514 10.5093Z"
        fill={color}
      />
    </svg>
  ),
)

StarIcon.displayName = 'StarIcon'
